import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { installChunkRecovery } from './lib/chunkRecovery';
import { installAuthConsoleGuard } from './lib/authConsoleGuard';
import { initSentry, Sentry } from './lib/sentry';
import App from './App';
import reportWebVitals from './reportWebVitals';

const CANONICAL_ORIGIN = 'https://sitescopeapp.com';
const VERCEL_ALIAS_HOSTS = new Set([
  'site-scope-gamma.vercel.app',
  'site-scope-geektronics-projects.vercel.app',
  'site-scope-git-main-geektronics-projects.vercel.app',
]);

const shouldRedirectToCanonical = VERCEL_ALIAS_HOSTS.has(window.location.hostname);

if (shouldRedirectToCanonical) {
  window.location.replace(`${CANONICAL_ORIGIN}${window.location.pathname}${window.location.search}${window.location.hash}`);
}

if (!shouldRedirectToCanonical) {
  installAuthConsoleGuard();
  installChunkRecovery();
  initSentry();

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <Sentry.ErrorBoundary fallback={<div style={{ padding: 24, fontFamily: 'sans-serif' }}>SiteScope hit an unexpected error. Please refresh the app.</div>}>
        <App />
      </Sentry.ErrorBoundary>
    </React.StrictMode>
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
}

if (!shouldRedirectToCanonical && process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    let refreshing = false;

    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });

    navigator.serviceWorker
      .register('/service-worker.js')
      .then(reg => {
        // Check immediately on page load so open Safari tabs pick up the latest
        // release without waiting for the next five-minute poll.
        reg.update().catch(err => console.warn('[SW] Update check failed:', err));

        // Check for a new version every 5 minutes
        setInterval(() => reg.update(), 5 * 60 * 1000);

        // iOS PWAs resumed from the background never fire `load` again and the
        // interval timer is throttled while suspended — so also check on every
        // foreground transition. This is how deployed fixes reach long-lived
        // phone sessions in seconds instead of "whenever the app is restarted".
        const updateOnForeground = () => {
          if (document.visibilityState && document.visibilityState !== 'visible') return;
          reg.update().catch(err => console.warn('[SW] Foreground update check failed:', err));
        };
        window.addEventListener('pageshow', updateOnForeground);
        document.addEventListener('visibilitychange', updateOnForeground);

        // When a new SW installs, watch for it to activate then reload
        reg.addEventListener('updatefound', () => {
          const newWorker = reg.installing;
          if (!newWorker) return;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'activated' && navigator.serviceWorker.controller) {
              // New version is live — reload to serve fresh assets
              window.location.reload();
            }
          });
        });
      })
      .catch(err => console.warn('[SW] Registration failed:', err));
  });
}
